import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { OWNERSHIP_CHANGE_PACKET } from "./apiRoutes";

interface mutateProps {
  ocpId: string;
  data: any;
}

const mutateAddOCPIntakeDocument = async ({
  ocpId,
  data,
}: mutateProps) => {
  return await axiosAuth.put(
    `${OWNERSHIP_CHANGE_PACKET}/${ocpId}/intake-communication`,
    data,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
};

const useAddOCPIntakeDocumentMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddOCPIntakeDocument,
    ...queryParams,
  });

export default useAddOCPIntakeDocumentMutation;
